import { render } from "./ContentDoubtsForm.vue?vue&type=template&id=cf630764&scoped=true"
import script from "./ContentDoubtsForm.vue?vue&type=script&lang=js"
export * from "./ContentDoubtsForm.vue?vue&type=script&lang=js"

import "./ContentDoubtsForm.vue?vue&type=style&index=0&id=cf630764&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf630764"]])

export default __exports__